import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { autobind } from '../../packages/core/lib';
import {
    TransactionDetail,
    HeaderCompound,
    Grid
} from '../../packages/components';
import {
    showModal,
    MODAL_CALL_CENTER,
    AAF_MODAL_SUCCESS_SUSCRIPTION,
    AAF_MODAL_SUCCESS_SUSCRIPTION_PROD,
    AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT,
    AAF_MODAL_QR_PAYMENTS,
    AAF_MODAL_ERROR
} from '../../actions/modal';
import { TransactionDetailType } from '../../packages/components/lib/TransactionDetail';
import Spinner from '../../components/Spinner';
import Assets from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import { getwWorkflowstart, MODALS_2FA, parsePBI, parseWorkFlowStart } from './utils'
import { apiPaywayConfirm, onPaymetSuccess, showError, redirectPlayerOneClic, handleTypeModal, showActualizaTusDatos, showConfirmPurchase60Seconds, showLimiteCompras, showLimiteIntentos, continuePlay, showNecesitasAyudaConTuConfirmacion, showOnlineDebt} from '../utils/Utils';
import store from '../../store';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import {GETWAY_AMCO, GETWAY_CLAROPAGO, VCARD_CONTRATA, VCARD_COMPONENT, MONTHS, QRPAYMENTMODALCONFIG, DEFAULTQRPAYMENTMODALCONFIG, ADDEDITPAYMENTMETHODINFOCONFIG, DEFAULTADDEDITPAYMENTMETHODINFOCONFIG, EDITPAYMENTMETHODINFO, PAYPALGATE} from '../utils/constants';
import { setMetricsEvent } from '../../actions/metrics';
import { COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_AGREGAR_MEDIO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO, EVENT_ACTION_METODO_DE_PAGO } from '../../packages/components/lib/utils/constants';
import './_styles.scss';
import Utils, {setInitialFocus, enablePaymentMethodExperience} from 'src/utils/Utils';
import {getTransactionalPrice, getTransactionalTax, getTransactionalBonus, getTransactionalTaxPublicity} from '../utils/Utils';
import {TRANSACTION_COMPONENT_TICKET, TRANSACTION_COMPONENT_CHECKOUT, ENABLE_QR_SCREEN, QR_SCREEN, SUCCESFULL} from '../utils/constants';
import { Resilence } from 'src/AAF/Resilence/main';
import {GA4} from 'src/utils/trackers/GA4';
import { CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY } from 'src/utils/trackers/GA4Constants';
import HistoryRegion from '../../utils/HistoryRegion';
import { MODAL_REGISTER_NET } from '../../actions/modal';
import AAF from '../../AAF/AAF';
import { resetAfterLogin } from 'src/actions/ads';
import { setModalSuccessActive, resetModalSuccessActive } from '../../../src/actions/modalsuccesactive';
import AAFPlayer from 'src/AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY } from 'src/AAFPlayer/constants';
import { handleClickAddPaymentMethod, handleClickEditPaymentMethod } from 'src/authentication/components/LandingTelmex/utilsLandingTelmex';
import Metadata from '../../requests/apa/Metadata';
import { linkSessions } from 'src/payments/Checkout/utils.js';

const { isPTVUSer } = Resilence;

export interface IDetailPBI {
    isSubscription: boolean,
    isLive: boolean,
    bannerpromo: string,
    currency: string,
    gateway: string,
    key: string,
    linkworkflowstart: string,
    offerid: string,
    groupId?: string,
    islive?: boolean,
    extraDisclaimer?: string,
    oneofferdesc: string,
    oneofferdesckey: string,
    oneoffertype: string,
    paymentmethod: any,
    price: string,
    producttype: string,
    purchasechecked: string,
    purchaseid: string,
    waspurchased: string,
    family: string,
    bonus: string,
    buy: string,
    includes: string,
    frequency: number,
    style: string,
    periodicity: string,
    banner: string,
    hideTextStep?: boolean,
    backButtonAlign?: 'right' | 'left'
}
export interface IcardsData {
    pan: string;
}

export interface IWorkflowItem {
    gateway: string,
    gatewayText: string,
    buyLink: string,
    hubCorpEnabled: boolean,
    product_id: string,
    accessCode: boolean,
    msgAccessCode: string,
    producttype: string,
    buyToken: string,
    paymentMethodData: {
        account: string,
        cardsData: IcardsData[]
    },
    listBuyLinks: any
}

export interface IWorkflowContentInfo {
    contentImageLarge: string,
    contentImageMedium: string,
    contentImageSmall: string,
    contentTitle: string,
    contentOriginalTitle: string,
}

export interface IWorkflowstart {
    hasSavedPayway: boolean,
    hasUserSusc: string,
    list: IWorkflowItem[],
    newWorkflow: string,
    selectedPaymentMethod: string,
    contentInfo?: IWorkflowContentInfo,
    rentaDescripcionContent: string
}

export interface ITransactionDetailState {
    isLoading: boolean,
    worflowstart: IWorkflowstart,
    itemData: any,
    isPublicity: boolean,
    isModalSuccesActive: boolean
}

class TransactionDetailContainer extends Component<RouteComponentProps, ITransactionDetailState>{
    private pbi: IDetailPBI;
    private itemData: any;
    private from: string = '';
    private transactionType: TransactionDetailType;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private newMethod: string = '';
    public region: string = DeviceStorage.getItem('region');
    public userType = AAF.AdsUtils.getUserType();
    public propsAL = store.getState().ads && store.getState().ads.propsAfterLogin;
    public isModalSuccesActiveADDOn = store.getState().modal && store.getState().modal.modalType;
    public isPaymenMethod = '';
    public isNewModalTicket: boolean;
    public enablePaymentModal: any = null;
    public qrFlowConfig: any = null;
    private linkworkflowstartUrl: string = '';

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {}} = {} } = props || {};
        console.log('Estado completo:', state);
        const {itemData = {}} = state;
        this.itemData = itemData;
        this.pbi =  (Object.keys(this.propsAL).length) === 0 ?  parsePBI(state) : (this.propsAL && this.propsAL.stateAL && (this.propsAL.stateAL.type === 'plan-selector' || this.propsAL.stateAL.type === 'plan_selector') ? this.propsAL.stateAL : this.propsAL.pbi);
        this.newMethod = state.newMethod
        this.from = state.from;
        this.transactionType = this.getTransactionType();
        this.setInitialState();
        this.addEventListener();
        this.isPaymenMethod = props && props.history && props.history.location && props.history.location.state && props.history.location.state.isPaymenMethod;
        this.isNewModalTicket = this.getNewStylesModalPymentMethod();
        this.enablePaymentModal = Utils.getRegionaliazedMetadata('qr_payment_modal_config', ENABLE_QR_SCREEN);
        this.qrFlowConfig = Utils.getRegionaliazedMetadata('qr_flow_config', QR_SCREEN);
    }

    private getNewStylesModalPymentMethod(): boolean {
        let newStylesModalPaymentMethod = Utils.getRegionaliazedMetadata('new_styles_modal_payment_method', '{"default":{"enable":false},"mexico":{"enable":false}}');
        return newStylesModalPaymentMethod && newStylesModalPaymentMethod.enable;
    }

    @autobind
    private getTransactionType(): TransactionDetailType {

        const transactionType = this.props && this.props.location && this.props.location.state && this.props.location.state.from || this.propsAL && this.propsAL.stateAL && this.propsAL.stateAL.type;
        if(transactionType && (transactionType === 'plan-selector' || transactionType == 'plan_selector' )){
            return TransactionDetailType.SUSCRIPTION;
        }

        const { oneoffertype = '', producttype } = this.pbi;

        if (oneoffertype.toLowerCase().includes('buy')) {
            if (producttype.toLowerCase().includes('season')) {
                return TransactionDetailType.BUY_SEASON;
            } else if (producttype.toLowerCase().includes('episode')) {
                return TransactionDetailType.BUY_EPISODE;
            } else {
                return TransactionDetailType.BUY_MOVIE;
            }
        } else if (oneoffertype.toLowerCase().includes('rent')) {
            return TransactionDetailType.RENT_MOVIE;
        }
        else if (oneoffertype.toLowerCase().includes('subscription') || oneoffertype.toLowerCase().includes('subscrition')) {
            return TransactionDetailType.SUSCRIPTION;
        }
        else {
            throw new Error('[AAF Payment] Tipo de transaccion no asociado');
        }
    }

    private setInitialState(): void {
        this.state = {
            isLoading: true,
            worflowstart: {
                hasSavedPayway: false,
                hasUserSusc: '',
                newWorkflow: '',
                list: [],
                selectedPaymentMethod: '',
                isPublicity: false
            },
            isPublicity: false,
            isModalSuccesActive: false
        };
    };

    private addEventListener(): void {

    }

    private getWorkflow(gateway: string): IWorkflowItem | undefined {
        const { worflowstart: { list } } = this.state;

        if (list && list.length > 0) {
            return list.find(i => i.gateway === gateway);
        }

        if(list && list?.listBuyLinks) {
            return list?.listBuyLinks.find((i: any) => i.gateway === gateway);
        }

        return undefined;
    }

    /**
     * Handlers
     */

    @autobind
    private showModalSusc(groupId: number, provider: string, pbi: object, cb: any): void {
        const props = {
            groupId,
            provider,
            pbi,
            backCallback: cb
        }
        const modal = {
            modalType: MODAL_CALL_CENTER,
            modalProps: props
        };
        store.dispatch(showModal(modal));
    }

    

    @autobind
    private handleBack(e: any): void {
        const { history } = this.props;
        if(!AAF.AdsUtils.isAdsEnable()){
            if(MODALS_2FA.includes(Utils.modalType())) return
            history.goBack();
        }else{
            const navFrremium = this.propsAL && this.propsAL.stateAL && this.propsAL.stateAL.metricsHistory ? this.propsAL.stateAL.metricsHistory :
                            (this.props && this.props.location && this.props.location.state && this.props.location.state.metricsHistory)

            const urlFlowType = this.props.history.location && this.props.history.location.state && this.props.history.location.state.urlFlowType;
            const urlFlowTypeAL = this.propsAL &&  this.propsAL.stateAL &&  this.propsAL.stateAL.urlFlowType;
            if(!this.isFreemiumLogged() && !AAF.AdsUtils.isUserFreemium(this.userType) && !AAF.AdsUtils.isUserNavPremium(this.userType)){
                e.preventDefault();
                e.stopPropagation();
                history.goBack();
            }else{
                if(urlFlowType === undefined && urlFlowTypeAL === undefined){
                    history.replace(navFrremium || history.goBack());
                }else{
                    if(urlFlowType ==='/detailSelector' || urlFlowTypeAL ==='/detailSelector'){
                        const dataPBI = this.props && this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.historyPData2;
                        const dataOffer = this.props && this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.historyPDataN;
                        let propsPLB = dataPBI || dataOffer;
                        if(propsPLB === undefined){
                            const propsPLBPBI = this.propsAL.historyPData2; // Esta variable se crea para obtener los datos de navegación cuando el carrusel de plan selector viene de PBI
                            const propsPLBOffer = this.propsAL && this.propsAL.metricsHistory &&   // Esta variable se crea para obtener los datos de navegación cuando el carrusel de plan selector viene de la api de offer
                                                  this.propsAL && this.propsAL.metricsHistory.location &&
                                                  this.propsAL && this.propsAL.metricsHistory.location.state &&
                                                  this.propsAL.metricsHistory.location.state.historyPDataN;

                            propsPLB = propsPLBPBI || propsPLBOffer;
                        }
                        history.push(urlFlowType || urlFlowTypeAL, { propsPLB});
                    }else{
                        history.replace(urlFlowType ? urlFlowType : urlFlowTypeAL);
                    }
                }
                store.dispatch(resetAfterLogin());
            }
        }
    }

    @autobind
    private async handleAcceptSavedPayway(): Promise<void> {
        const twofaConfigMetadata=Utils.getRegionaliazedMetadata('2fa_config');
		const twofaConfigMetadataGateway = twofaConfigMetadata && twofaConfigMetadata.gateway;
		const isTelmexmexicogate = twofaConfigMetadataGateway && twofaConfigMetadataGateway.includes("telmexmexicogate");

        const { worflowstart } = this.state;
        let { worflowstart: { selectedPaymentMethod } } = this.state
        const { history } = this.props;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : selectedPaymentMethod;
        let selectedWorkFlow = this.getWorkflow(selectedPaymentMethodOrAmco);
        let { isSubscription, producttype } = this.pbi;
        let dataMetrics2FA = Utils.getDataMetrics(this.itemData, this.props.location.pathname);

        //validar si eres freemium logued y si la ads esta aciva obtenemos los datos de props
        this.userType = AAF.AdsUtils.getUserType();
        if(AAF.AdsUtils.isAdsEnable() && (AAF.AdsUtils.isFreemiumLogged(this.userType) || AAF.AdsUtils.isUserNavPremium(this.userType))){
            isSubscription = true;
            const provider = this.props && this.props.location && this.props.location.state && this.props.location.state.provider;
            producttype = provider ? provider : producttype;
        }

        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: object) => this.redirectVCard(resp);
        Utils.sendMetric(this.props, VCARD_CONTRATA, producttype.toLowerCase(), VCARD_COMPONENT);
        if (this.newMethod) {
            selectedWorkFlow = this.getWorkflow(this.newMethod);
            selectedPaymentMethod = this.newMethod;
        }
        if (selectedPaymentMethodOrAmco === GETWAY_CLAROPAGO) {
            history.push(`/payment-${selectedPaymentMethod}`, { pbi: this.pbi, worflowstart, method: selectedPaymentMethod, type: this.transactionType, changeMethod: false });
        } else {
            this.setState({ isLoading: true });
            //this.sendGA4Metric(this.transactionType  === TransactionDetailType.SUSCRIPTION ? 'F1':' F2', selectedPaymentMethod);

            let formParams = {}
            
            // Flujo para el método de pago Paypal
            if (selectedPaymentMethod && selectedPaymentMethod === PAYPALGATE) {
                // Se obtienen la cuentas asociadas
                const paypalAccounts = 
                    selectedWorkFlow && 
                    selectedWorkFlow.paymentMethodData && 
                    selectedWorkFlow.paymentMethodData.paypalAccounts

                // Se obtiene la cuenta por default
                const defaultAccount = Array.isArray(paypalAccounts) 
                    ? paypalAccounts.find(item => item.isDefault === true) 
                    : undefined;
                
                // Si existe una cuenta default, se obtiene la data para extra_params
                if (defaultAccount) {
                    formParams = {
                        payment_token_id: defaultAccount.paymentTokenId || null
                    }
                }
            }

            apiPaywayConfirm({ pbi: this.pbi, wfs: selectedWorkFlow, formParams })
                .then((resp) => {
                    const dataBuyconfirm = resp && resp.data ? resp.data : resp.response;
                    localStorage.setItem('buyConfirmData', JSON.stringify(dataBuyconfirm));
                    
                    const twofaConfigMetadata = Utils.getRegionaliazedMetadata('2fa_config');
                    const twofaConfigEnable = twofaConfigMetadata && twofaConfigMetadata.enable;
                    const twofaConfigGateway = twofaConfigMetadata && twofaConfigMetadata.gateway;
		            const isTelmexmexicogate = twofaConfigGateway && twofaConfigGateway.includes("telmexmexicogate");

                    const { groupId = '', islive = false } = this.pbi;
                    //this.sendGA4Metric('F3', undefined, '4');
                    if(isSubscription && AAF.AdsUtils.isAdsEnable()){
                        this.setState({ isModalSuccesActive: true });
                    }

                    if (twofaConfigEnable && isTelmexmexicogate) {
                        // Flujo 2FA Telmex
                        history.goBack()
                        // SE DA TIEMPO PARA HACER LA NAVEGACION A LA URL ANTERIOR
                        setTimeout(() => {
                            const previousDate2FA = DeviceStorage.getItem("fecha_2FA");
                            const currentDate = new Date();
                            const currentDate2FA = `${currentDate.getDate()} / ${MONTHS[currentDate.getMonth()]}`

                            if (previousDate2FA !== currentDate2FA) {
                                DeviceStorage.setItem('count_2FA', '0');
                                DeviceStorage.setItem('max_num_resend_2FA', '0');
                                DeviceStorage.setItem('fecha_2FA', currentDate2FA);
                            }

                            if (dataBuyconfirm && dataBuyconfirm.code === "G3_WAITING_2FA" && dataBuyconfirm.transactionId !== null) {
                                // Flujo - Esperando que el usuario confirme la transacción con 2FA
                                const countResend = parseInt(DeviceStorage.getItem("count_2FA"));
                                const maxNumResend = parseInt(DeviceStorage.getItem("max_num_resend_2FA"));
                                if (countResend && maxNumResend && (countResend >= maxNumResend)) {
                                    showLimiteIntentos(dataMetrics2FA);
                                    if (AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_PLAY ) {
                                        AAFPlayer.pause();
                                    }
                                } else {
                                    const dataToShowTicket = {
                                        showTicket: this.showTicket,
                                        groupId,
                                        islive,
                                        worflowstart
                                    }
                                    localStorage.setItem('ModalRemember', "");
                                    showConfirmPurchase60Seconds(dataBuyconfirm, dataToShowTicket,dataMetrics2FA);
                                }
                                this.setState({ isLoading: false });
                            } else if (dataBuyconfirm && dataBuyconfirm.code === "G3_NODATA_2FA") {
                                // Flujo - Que el usuario actualice sus datos para poder hacer su transacción con 2FA
                                showActualizaTusDatos(dataMetrics2FA);
                                this.setState({ isLoading: false });
                            } else {
                                // Flujo - Lista Blanca
                                this.showTicket(dataBuyconfirm, groupId, islive, true);
                            }
                        }, 100)
                    } else {
                        this.sendGA4Metric('F3', undefined, '4');
						onPaymetSuccess(resp, this.pbi, selectedWorkFlow, selectedPaymentMethodOrAmco, cb, true);
                    }
                })
                .catch(err => {
                    history.goBack()
                    // SE DA TIEMPO PARA HACER LA NAVEGACION A LA URL ANTERIOR
                    setTimeout(() => {
                        // Si existen errores en los datos de la confirmación de la compra. Status 400.
                        const purchaseConfirmationDataErrors = ["PGS_G3_00251", "PGS_TMX_000", "PGS_G3_00384", "PGS_G3_00250"];
                        const hasPurchaseConfirmationDataError = err && purchaseConfirmationDataErrors.includes(err.code);

                        // Si existen errores en la confirmación de la compra. Status 400 y 401.
                        const purchaseConfirmationErrors = ["PGS_CSE_00001", "PGS_PMT_00006", "USR_JWT_00003"];
                        const hasPurchaseConfirmationErrors = err && purchaseConfirmationErrors.includes(err.code);

                        // Si existen una "Transacción iniciada previamente". Status 400.
                        const previouslyInitiatedTransactionErrors = ["PGS_2FA_00001"];
                        const hasPreviouslyInitiatedTransactionErrors = err && previouslyInitiatedTransactionErrors.includes(err.code);

                        // Si existen CIERTOS errores en la confirmación de la compra. Status 400.
                        const limitPurchaseErrors = ["PGS_G3_00702", "PGS_G3_00779"];
                        const hasLimitPurchaseErrors = err && limitPurchaseErrors.includes(err.code)

                        // Si existe "Adeudo en la línea Telmex". Status 400.
                        const onlineDebtErrors = ["PGS_G3_00700", "PGS_G3_00701", "PGS_G3_00385"];
                        const hasOnlineDebtErrors = err && onlineDebtErrors.includes(err.code)

                        if (hasPurchaseConfirmationDataError) {
                            showActualizaTusDatos(dataMetrics2FA);
                        } else if (hasPurchaseConfirmationErrors) {
                            showError(err);
                        } else if (hasPreviouslyInitiatedTransactionErrors) {
                            showNecesitasAyudaConTuConfirmacion(dataMetrics2FA);
                        } else if(hasLimitPurchaseErrors){
                            showLimiteCompras(dataMetrics2FA);
                        } else if (hasOnlineDebtErrors) {
                            showOnlineDebt(dataMetrics2FA);
                        } else {
                            showError(err);
                        }
                        
                        this.setState({ isLoading: false });
                    }, 100)
                });
        }
    }

    @autobind
    private sendGA4Metric(ga4Id:string, selectedPaymentMethod?: string, transaction_id?: string) {
        const gA4 = new GA4();
        const {price, offerid} = this.pbi || {}
        const {item_name, item_id, item_brand, item_category, item_category2, item_category3, item_category4} = this.itemData;
        if (ga4Id === 'F1'){
            gA4.sendPaymentMethodAddedEvent(selectedPaymentMethod || '',item_brand,item_id, price, item_brand, DOES_NOT_APPLY,DOES_NOT_APPLY,item_category3,DOES_NOT_APPLY,1);
        } else if (ga4Id === 'F2') {
            gA4.sendPaymentMethodAddedEvent(selectedPaymentMethod || '',item_name,item_id, price, item_brand, item_category,item_category2,item_category3,item_category4,1);
        } else if (ga4Id === 'F3') {
            if (this.transactionType === TransactionDetailType.SUSCRIPTION) {
                gA4.sendBuyEvent(price, offerid,DOES_NOT_APPLY,item_brand,item_id,price,item_brand,DOES_NOT_APPLY, DOES_NOT_APPLY, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY)
            } else {
                gA4.sendBuyEvent(price, offerid,DOES_NOT_APPLY,item_brand,item_id,price,item_brand,DOES_NOT_APPLY, DOES_NOT_APPLY, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION, DOES_NOT_APPLY)
            }
        }
    }

    @autobind
    private async getCode(hasSavedPayway: boolean): Promise<void> {
        try{
            const redirectUrl = hasSavedPayway ? this.qrFlowConfig.config.editmdp.url : this.qrFlowConfig.config.addmdp.url;
            const qrFlowConfig = hasSavedPayway ? this.qrFlowConfig.config.editmdp : this.qrFlowConfig.config.addmdp;
            const pullingDurationSeconds = this.qrFlowConfig.pulling_duration_seconds;
            const qrRetries = this.qrFlowConfig.qr_retries;
            const response = await linkSessions(redirectUrl, 'POST', '', qrRetries, this.linkworkflowstartUrl);
            const dataLinkSessions = response && response.data;
            if (!dataLinkSessions || (!dataLinkSessions.code && !dataLinkSessions.qrCode)) {
                store.dispatch(showModal({ modalType: AAF_MODAL_ERROR, modalProps: {} }));
                return;
            }
            const modal = {
                modalType: AAF_MODAL_QR_PAYMENTS,
                modalProps: {
                    response: dataLinkSessions,
                    qrFlowConfig,
                    pullingDurationSeconds,
                    qrRetries,
                    onStatusChange: this.handleQrStatusChange,
                }
            };
            store.dispatch(showModal({
                ...modal
            }));
        } catch (error) {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {}
            }
            store.dispatch(showModal(modal));
        }
    }

    @autobind
    private handleQrStatusChange(status: string): void {
        if (status === SUCCESFULL) {
            this.setState({ isLoading: true }, () => this.getData());
        }
    }

    @autobind
    private getQRPaymentModalConfig(): boolean {
        const qrModalCOnfig = Utils.getRegionaliazedMetadata(QRPAYMENTMODALCONFIG, DEFAULTQRPAYMENTMODALCONFIG);
        return qrModalCOnfig && qrModalCOnfig.enable;
    }

    @autobind
    private handleAddPayway(e: any): void {
        const qrModalCOnfig = this.enablePaymentModal && this.enablePaymentModal.enabled;
        const { worflowstart, worflowstart: { hasSavedPayway } } = this.state;

        if(qrModalCOnfig){
            this.getCode(hasSavedPayway);
        } else {
            Utils.sendMetric(this.props, EVENT_ACTION_METODO_DE_PAGO,LABER_AGREGAR_MEDIO_DE_PAGO, METODO_DE_PAGO);
            const { history, location } = this.props;
            const changeMethod = hasSavedPayway ? true : false;
            const metricsHistory = this.props.location.state != undefined ? this.props.location.state.metricsHistory : this.propsAL.stateAL.metricsHistory;
            history.push('/payment-method', { pbi: this.pbi, worflowstart, type: this.transactionType, from: this.from, changeMethod, location, metricsHistory  });
        }
    }

    @autobind
    private handleCancelPayway(): void {
        const { history } = this.props;
        Utils.sendMetric(this.props, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO, COMPONENT_PLAN_SELECTOR)
        if(!AAF.AdsUtils.isAdsEnable() ){
            history.goBack();
        }else{
            store.dispatch(resetAfterLogin());
            if(Object.keys(this.propsAL).length > 0){
                history.replace(this.propsAL.stateAL.metricsHistory || this.propsAL.stateAL.urlFlowType);
            }
            else{
                history.goBack();
            }
        }
    }

    @autobind
    private handleLoginFreemium(): void {
        const { history } = this.props;
        let propsFreemium = {
            pbi: this.pbi,
            metricsHistory: this.props,
            stateAL: this.props.location.state !== undefined ? this.props.location.state : this.propsAL.stateAL,
            forceReset: this.props.location.state !== undefined ? this.props.location.state && this.props.location.state.forceReset  : this.propsAL.stateAL.forceReset,
            historyPData2: this.props.location.state !== undefined ? this.props.location.state && this.props.location.state.historyPData2  : this.propsAL.historyPData2,
        }

        //Validar y quitar
        if(this.props.location && this.props.location.state && this.props.location.state.urlLive !== undefined) {
            propsFreemium["urlLive"] = this.props.location.state.urlLive;
        }

        AAF.AdsUtils.redirectToLogin(history, propsFreemium);
    }

    /**
     * React Lifecycle Methods
     */

    shouldComponentUpdate(nextProps: any, nextState: any) {
        // Evita re-renderizar si isModalSuccesActive es true
        if(AAF.AdsUtils.isAdsEnable()){
            if (nextState.isModalSuccesActive !== this.state.isModalSuccesActive) {
                const isModalSuccesActive = nextState.isModalSuccesActive;
                store.dispatch(setModalSuccessActive({
                    isModalSuccesActive
                }));
                return false;
            }
            return true;
        }else{
            return true;
        }
    }

    componentDidMount() {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const { user } = store.getState() || {};
        const isModalSuccess = store.getState().modalsuccesactive && store.getState().modalsuccesactive.isActiveModalSuccess;

        //Obtenemos datos de utils para saber si es freemium no logueado
        this.userType = AAF.AdsUtils.getUserType();


        //Si es freemium sin registrar lo enviamos a checkout para mostrar solo datos sin invocar workflow
        if(AAF.AdsUtils.isAdsEnable() && AAF.AdsUtils.isUserFreemium(this.userType)){
            this.setState({isPublicity: true, isLoading: false }, () =>{
                if(Utils.isModalHide()){
                    setInitialFocus('.initial-focus', false);
                }
            });
        }else{
            if (user.isLoggedIn) {
                if(AAF.AdsUtils.isAdsEnable()){
                    if(!isModalSuccess){
                        this.getData();
                        this.addEventListener();
                    }
                }else{
                    this.getData();
                    this.addEventListener();
                }
            }
            else {
                this.sendAnonymousUserToRegister()
            }
        }
    }

    componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW' || currentKey === 'BACK') {
            e.preventDefault();
            e.stopPropagation();
            if (Utils.isModalHide()) {
                this.handleBack(e);
            }
        }
    }

    @autobind
    private sendAnonymousUserToRegister() {
        const { history, location: { state: pbi = {} } = {} } = this.props;
        history.push(`/register`, { ...pbi, isRedirectFromCheckout: true });
    }

    @autobind
    private redirectAddon(resp: any): void {
        this.setState({ isLoading: false });
        const { groupId = '', oneoffertype = '', islive = false } = this.pbi;
        const { worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    @autobind
    private handleHomeAddOn(resp: any) {
        const { history } = this.props;
        const { navbar = {} } = store.getState() || {};
        const { nodes = [] } = navbar;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];

            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }
        if(AAF.AdsUtils.isAdsEnable()){
            const isModalSuccesActive = false
            store.dispatch(resetModalSuccessActive());
        }
        // Este flujo solo es desde el plan selector
        const homeNode = (nodes && nodes[0] && nodes[0].code) || 'homeuser';
        history.replace(`/node/${nodeString ? nodeString : homeNode}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        const { history } = this.props;
        const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
        if (islive) {
            redirectPlayerOneClic(groupId, islive, payway_token, null, () => {
                if(nav && nav.home) {
                    history.replace(`/node/${nav.home}`);
                  }             });
        } else if (groupId) {
            if(AAF.AdsUtils.isAdsEnable()){
                this.handleVCard(groupId);
            }else{
                redirectPlayerOneClic(groupId, islive, payway_token, () => {
                    this.handleVCard(groupId);
                }, null)
            }
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean, is2FA: boolean) {
        let  { currency, price, family, periodicity = '', bonus, frequency = '', producttype } = this.pbi;
        const { response: { end_date: { day = '', month = '', year = '' } = {}, paymentMethodData: { account = '', gateway = '' } = {}, payway_token = '' } = {} } = resp || {};
        const next_pay = `${day} ${Translator.get(month)} ${year}`;
        let transactional_bonus = '';
        const adsIsEnable = AAF.AdsUtils.isAdsEnable();
        const isUserFreemiumOrFreemiumLoggedOrNavPremium = AAF.AdsUtils.isUserFreemiumOrFreemiumLoggedOrNavPremium(this.userType);
        const isPlanSelectorCintillo = this.props && this.props.location && this.props.location.state && this.props.location.state.isPlanSlectorCintillo === true;
        const isPaypal = gateway === PAYPALGATE
        //* Ejemplo nueva key: Ticket_Transaccion_TextoDescripcion_{producttype}
        const newaccount = enablePaymentMethodExperience() && isPaypal ? 
            Utils.cutPlayerString(account, 19) : 
            String(account).slice(-8);

        if(AAF.AdsUtils.isUserFreemiumOrFreemiumLoggedOrNavPremium(this.userType)){
            producttype = this.props && this.props.location && this.props.location.state && this.props.location.state.provider;
            transactional_bonus = `transactional_bonus_${producttype}_subscription_tryInvite_description`;
            price = price.amount;
            family = (AAF.AdsUtils.isUserFreemiumOrFreemiumLoggedOrNavPremium(this.userType) && this.props?.location?.state?.type !== '' && !isPlanSelectorCintillo) ? producttype : family;
        }

        const apaKeyContent = `Ticket_Transaccion_TextoDescripcion_${producttype}`;
        const { worflowstart: { selectedPaymentMethod = '' } = {} } = this.state;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : selectedPaymentMethod;
        
        const _paypalLabel = Translator.get('mdp_metodosdepago_ticket_texto_parrafo_paypal');
        const labelPaymentMethod = enablePaymentMethodExperience() && isPaypal ? 
            (_paypalLabel && _paypalLabel.length > 0 ? Utils.cutPlayerString(_paypalLabel, 6) : '') : 
            Translator.get(`ticket_subscription_${selectedPaymentMethodOrAmco}_label`);
            
        transactional_bonus = `transactional_${bonus}_subscription_tryInvite_description`;
        let data: any = {}

        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
            case TransactionDetailType.RENT_MOVIE:
                const { worflowstart: { contentInfo: { contentImageMedium, contentTitle } = {} } } = this.state;
                const duration = Translator.get(periodicity)
                data = {
                    pbi: this.pbi,
                    type: this.transactionType,
                    total: null,
                    days: null,
                    content: null,
                    payment_method: newaccount,
                    img_large: contentImageMedium,
                    providerImage: null,
                    contentTitle,
                    transactionType: this.transactionType,
                    labelPaymentMethod,
                    next_pay: frequency == 0 ? null : `${frequency} ${duration}`,
                    is2FA: is2FA,
                };
                break;
            case TransactionDetailType.SUSCRIPTION:
                // Se deja lo que ya estaba
                const daysPrefix = Translator.get(transactional_bonus, '')
                const daysContent = Translator.get(`bonus_${producttype}`, '')
                const ticketPrice = getTransactionalPrice({
                    component: TRANSACTION_COMPONENT_TICKET,
                    currency:currency,
                    price:price
                    });
                const ticketBonus = getTransactionalBonus({
                    component: TRANSACTION_COMPONENT_TICKET,
                    bonus,
                    producttype,
                    family
                });

                data = {
                    pbi: this.pbi,
                    type: this.transactionType,
                    total: ticketPrice, //[Ticket] Price Ej. $ 9999 / Mes,
                    bonus: ticketBonus,
                    days: `${daysPrefix} ${daysContent}`,
                    content: `${Translator.get(apaKeyContent, '')}`,
                    payment_method: newaccount,
                    next_pay,
                    img_large: this.getContentImage(adsIsEnable,isUserFreemiumOrFreemiumLoggedOrNavPremium),
                    img_largeSub: isUserFreemiumOrFreemiumLoggedOrNavPremium ? this.getContentImage(adsIsEnable,isUserFreemiumOrFreemiumLoggedOrNavPremium) : Assets.get(`${this.region}_transactional_${family}_poster`, ''),
                    providerImage: this.getProviderImage(adsIsEnable, isUserFreemiumOrFreemiumLoggedOrNavPremium),
                    labelPaymentMethod,
                    from: this.from,
                    islive: this.props.location.state != undefined ? this.props.location.state.islive : this.propsAL.stateAL.islive,
                    groupId: this.props.location.state != undefined ? this.props.location.state.islive : this.propsAL.stateAL.groupId,
                    is2FA: is2FA,
                };
                break;
            default:
                data = {};
        }

        const modal = {
            modalType: this.isNewModalTicket ? AAF_MODAL_SUCCESS_SUSCRIPTION : AAF_MODAL_SUCCESS_SUSCRIPTION_PROD,
            modalProps: {
                data: handleTypeModal({ ...data}),
                handlePlay: () => this.from ? this.handleHomeAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => (this.props.location.state != undefined ? this.props.location.state.islive : this.propsAL.stateAL.islive) ? this.handleHomeAddOn(resp) : this.handleVCard(groupId),
                payment_methods_experience: enablePaymentMethodExperience(),
                callbackWhenBack: () => {
                    if (is2FA) {
                        continuePlay();
                    }
                }
            }
        };

        store.dispatch(showModal(modal));

    }

    private showBonus(bonus: string) {
        if (bonus === '') {
            return false;
        } else {
            return bonus !== Translator.get(bonus)
        }
    }

    private redirectVCard(resp: any): void {
        this.setState({ isLoading: false });
        const { groupId = '', oneoffertype = '', islive = false } = this.pbi;
        const { worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        }
        else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private getData(): void {
        const continueAfterLogin = store.getState().ads && store.getState().ads.continueAfterLogin;
        const paywayMethods = store.getState() && store.getState().user && store.getState().user.paywayProfile && store.getState().user.paywayProfile.paymentMethods
        const hasPaywayMethods = paywayMethods && paywayMethods.length > 0 ? true : false;

        let { offerid, groupId, group_id = "" } = this.pbi;
        groupId = groupId && groupId !== '' ? groupId : group_id;

        const { history, location: { state: { href = '' } = {} } = {} } = this.props;
        let { linkworkflowstart, href: href_stateAl = "" } = this.pbi;

        linkworkflowstart = linkworkflowstart && linkworkflowstart !== '' ? linkworkflowstart : href_stateAl;
        //validar si eres freemium logued y si la ads esta aciva obtenemos los datos de props
        this.userType = AAF.AdsUtils.getUserType();
            linkworkflowstart = href || linkworkflowstart;

        this.linkworkflowstartUrl = linkworkflowstart;

        getwWorkflowstart(linkworkflowstart, groupId, offerid).then((resp) => {
            const ws: IWorkflowstart = parseWorkFlowStart(resp.response);
            if(AAF.AdsUtils.isAdsEnable() && continueAfterLogin && !hasPaywayMethods && !this.isPaymenMethod){ //Se valida si es publicidad, el escenario es después de loguearte o registrarte y si no tiene metodos de pago asociados
                this.validIsAfterLoginAndRegister(ws);
            }else{
                this.setState({ worflowstart: ws, isLoading: false }, () =>{
                    if(Utils.isModalHide()){
                        setInitialFocus('.initial-focus', false);
                    }
                });
            }
        }).catch((err) => {
            if(err === "Workflowstart retry") return;
            const isIPTV = isPTVUSer();
            console.log("@@@@@ ERR CODE:", err)

            if (isIPTV && err.code === 'loggin_required') {
                history.goBack();
            } else {
                this.setState({ isLoading: false }, () => {
                    showError(err, history.goBack());
                });
            }
        });
    }

    private callAddPayway(worflowstart: any): void {
        Utils.sendMetric(this.props, EVENT_ACTION_METODO_DE_PAGO,LABER_AGREGAR_MEDIO_DE_PAGO, METODO_DE_PAGO);
        const {  hasSavedPayway  } = worflowstart;
        const { history, location } = this.props;
        const changeMethod = hasSavedPayway ? true : false;
        const metricsHistory = this.props.location.state != undefined ? this.props.location.state.metricsHistory : this.propsAL.stateAL.metricsHistory ;
        history.push('/payment-method', { pbi: this.pbi, worflowstart, type: this.transactionType, from: this.from, changeMethod, location, metricsHistory  });
    }


    private validIsAfterLoginAndRegister(ws: any){
        if(ws && ws.list && ws.list.length > 0){
            this.callAddPayway(ws);
        }
    }

    private getProviderImage(adsIsEnable = false, isUserFreemiumOrFreemiumLoggedOrNavPremium = false, isPlanSelectorCintillo = false): string {

        const { family } = this.pbi;

        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.RENT_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return '';
            case TransactionDetailType.SUSCRIPTION:
                if((adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium && !isPlanSelectorCintillo) && !family){
                    return  this.props && this.props.location && this.props.location.state && this.props.location.state.logo && this.props.location.state.logo.logo
                }else {
                    const assetName = `transactional_${family}_logo`;
                    return Assets.get(assetName, assetName);
                }
            default:
                return '';
        }
    }

    private getContentImage(adsIsEnable = false, isUserFreemiumOrFreemiumLoggedOrNavPremium = false): string {
        const { banner } = this.pbi;
        let image = '';
        if (this.transactionType === TransactionDetailType.SUSCRIPTION || isUserFreemiumOrFreemiumLoggedOrNavPremium) {
            if(adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium && banner === undefined){
                image = this.props && this.props.location && this.props.location.state && this.props.location.state.cover
            }else {
                const imageKey = `${this.region}_transactional_${banner}_poster`;
                image = Assets.get(imageKey, '');
            }
        }
        return image;
    }

    private getTitle(): string {
        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return AAF.AdsUtils.isUserNavPremium(this.userType)  ? Translator.get('Transaccionales_Compra_TextoTitulo', '') : Translator.get('checkout_purchase_title_label', '');
            case TransactionDetailType.RENT_MOVIE:
                return AAF.AdsUtils.isUserNavPremium(this.userType) ? Translator.get('Transaccionales_Renta_TextoTitulo', '') : Translator.get('checkout_rent_title_label', '');
            case TransactionDetailType.SUSCRIPTION:
                return AAF.AdsUtils.isUserNavPremium(this.userType) ? Translator.get('Transaccionales_Suscripcion_TextoTitulo', '') : Translator.get('checkout_subscription_title_label', '');
            default:
                return '';
        }
    }

    private isFreemiumLogged(){
        const FAL = AAF.AdsUtils.isFreemiumLogged(this.userType);
        const continueAfterLogin = store.getState().ads && store.getState().ads.continueAfterLogin

        return FAL && continueAfterLogin ? true : false;
    }

    private getTextButtonAccept() {
        switch (this.transactionType) {
            case TransactionDetailType.BUY_MOVIE:
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                return Translator.get('checkout_access_option_button_purchase', 'COMPRAR');
            case TransactionDetailType.RENT_MOVIE:
                return Translator.get('checkout_access_option_button_rent', 'ALQUILAR');
            case TransactionDetailType.SUSCRIPTION:
                return Translator.get('checkout_access_option_button_suscribtion', 'CONTRATAR');
            default:
                return '';
        }
    }

    private getTextButtonnNextFreemium() {
        return Translator.get('Transaccionales_Renta_TextoBotonPrimario', 'INGRESA PARA CONTINUAR');
    }

    private getTextAddPaywayButton(hasSavedPayway: boolean) {
        return hasSavedPayway ? Translator.get(`checkout_access_option_button_selectPayment`, 'CAMBIAR MEDIO DE PAGO') :
            Translator.get(`checkout_access_option_button_addPayment`, 'AGREGAR MEDIO DE PAGO');
    }

    private hasAmcoPayment() {
        //solo tienen un metodo de pago y es amcogate
        const { worflowstart: { list } } = this.state;

        if (list && list.length === 1) {
            const existsAmco = list.find(i => i.gateway === GETWAY_AMCO);
            if (existsAmco) {
                return true
            }
            return false
        }
        return false;
    }

    private gethasAmcoPayment(list: any){
        if(this.hasAmcoPayment()){
            return list && list.length > 1;
        } else {
            return  list && list.length >= 1;
        }
    }


    @autobind
    private getPaymentMethod() {
        const { worflowstart: { selectedPaymentMethod = '' } = {} } = this.state;
        const selectedPaymentMethodOrAmco = this.hasAmcoPayment() ? GETWAY_AMCO : this.newMethod ? this.newMethod: selectedPaymentMethod;
        const labelPaymentMethod = Translator.get(`ticket_subscription_${selectedPaymentMethodOrAmco}_label`);
        const {paymentMethodData : {account = false, cardsData = [{ pan: ''}], paypalAccounts = []} = {}} = this.getWorkflow(selectedPaymentMethodOrAmco) || {};

        // Solo para transacciones con Paypal
        if (enablePaymentMethodExperience()) {
            const isPaypal = selectedPaymentMethod === PAYPALGATE
            if (isPaypal) {
                // STVCL-2216: la cuenta vinculada de Paypal (formato usuario@dominio.com)
                // no viene en paymentMethodData.account (ese es un id interno, ej.
                // "cv-user-143251670") -- viene en paymentMethodData.paypalAccounts,
                // un arreglo del que hay que tomar la cuenta con isDefault === true.
                const defaultPaypalAccount = Array.isArray(paypalAccounts)
                    ? paypalAccounts.find(item => item.isDefault === true)
                    : undefined;
                const paypalAccountEmail = defaultPaypalAccount ? defaultPaypalAccount.email : '';

                const payLabel = Translator.get('mdp_checkout_metodoelegido_parrafo_texto1');
                const withPaypalLabel = Translator.get('mdp_checkout_metodoelegido_parrafo_texto2_paypal');
                const parts = [
                    payLabel && payLabel.length > 0 ? Utils.cutPlayerString(payLabel, 8) : '',
                    withPaypalLabel && withPaypalLabel.length > 0 ? Utils.cutPlayerString(withPaypalLabel, 6) : '',
                    paypalAccountEmail && paypalAccountEmail.length > 0 ? Utils.cutPlayerString(paypalAccountEmail, 19) : ''
                ].filter(Boolean);
                return parts.join(' ');
            }
        }
        
        if (this.hasAmcoPayment()){
            return `${Translator.get('checkout_payment_description_label', 'Paga con')} ${labelPaymentMethod}`
        } else if (account){
            const labelPayment = selectedPaymentMethod === 'claropagosgate' ? cardsData[0].pan : account;
            const newlabelPayment = String(labelPayment).slice(-8);
            return `${Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`)} ${newlabelPayment}`
        } else{
            return '';
        }
    }

    render(): JSX.Element {
        const isPlanSelectorCintillo = this.props && this.props.location && this.props.location.state && this.props.location.state.isPlanSlectorCintillo === true;
        let { currency, price, family, periodicity, producttype, backButtonAlign = 'right', bonus = '', extraDisclaimer = false, frequency, oneoffertype} = this.pbi;
        const { isLoading, worflowstart: { hasSavedPayway, list, rentaDescripcionContent, contentInfo: { contentImageMedium, contentTitle, contentOriginalTitle } = {} } } = this.state;
        const {history:{location:{state:{from = ''}={}}={}}={}} = this.props || {};
        const showSavedPaywayButton = hasSavedPayway || this.hasAmcoPayment();
        const showAddPaywayButton = this.gethasAmcoPayment(list);
        const isUserFreemiumOrFreemiumLoggedOrNavPremium = AAF.AdsUtils.isUserFreemiumOrFreemiumLoggedOrNavPremium(this.userType);
        const adsIsEnable = AAF.AdsUtils.isAdsEnable();
        const provider = this.props && this.props.location && this.props.location.state && this.props.location.state.provider;

        producttype = !producttype ? (adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium && this.props?.location?.state?.type !== '' && !isPlanSelectorCintillo) ? provider : producttype : producttype;
        if( (Object.keys(this.propsAL).length) > 0){
            producttype = !producttype ? (this.propsAL && this.propsAL.stateAL.provider) ? this.propsAL.stateAL.provider : producttype : producttype;
        }

        family = !family ? (adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium && this.props?.location?.state?.type !== '' && !isPlanSelectorCintillo) ? provider : family : family;

        const information = Translator.get(`Checkout_Transaccion_TextoDescripcion_${producttype}`, '');
        const disclaimer = Translator.get(`${family}_disclaimer_description_label`, 'No incluye Compra y renta u otro servicio  de suscripción. Puedes cancelar......');
        const extra_disclaimer = extraDisclaimer ? extraDisclaimer : Translator.get(`checkout_myContents_description_label`, '');
        const textBuySuscription = Translator.get(`${family}_scope_description_label`, '');
        const titleSerie = Utils.getTitleSerie();

        const textDescriptionContent =  Translator.get(`Checkout_Transaccion_TextoDescripcion_${producttype}`, '');
        const titleTitlePublicity = Utils.getdataResultTitle();
        let imagePublicity = Utils.getdataResultImage();
        const isFreemium = AAF.AdsUtils.isUserFreemium(this.userType);
        imagePublicity = !imagePublicity  ? adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium ? this.getContentImage(adsIsEnable, isUserFreemiumOrFreemiumLoggedOrNavPremium) : imagePublicity : imagePublicity;
        if( (Object.keys(this.propsAL).length) > 0){
            imagePublicity = !imagePublicity  ? (adsIsEnable && isUserFreemiumOrFreemiumLoggedOrNavPremium) ? this.propsAL.stateAL.portrait : imagePublicity : imagePublicity;
        }

        const checkoutPrice = getTransactionalPrice({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            price,
            currency,
            adsIsEnable,
            isUserFreemiumOrFreemiumLoggedOrNavPremium,
            isPlanSelectorCintillo
        });
        const checkoutTax = getTransactionalTax({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            producttype,
            periodicity,
            oneoffertype,
            frequency: String(frequency),
            adsIsEnable,
            isFreemium,
            isPlanSelectorCintillo
        })
        const checkoutBonus = getTransactionalBonus({
            component: TRANSACTION_COMPONENT_CHECKOUT,
            bonus,
            producttype,
            family,
            adsIsEnable
        });

        const checkoutTaxPublicity = checkoutTax

        if (isLoading) {
            return <Spinner className="checkout" loadingMessage='' />
        }
        else {
            return (
                <Grid>
                    <HeaderCompound
                        align={backButtonAlign}
                        disabled
                        onClick={(e) => this.handleBack(e)}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Assets.get('top_head_option_back')}`}
                    />
                    <TransactionDetail
                        transactionDetailType={this.transactionType}
                        textBackButton={Translator.get('top_head_option_button_back', 'Regresar')}
                        imgBackButton={Assets.get('top_head_option_back')}
                        title={this.getTitle()}
                        contentImage={contentImageMedium ? contentImageMedium : this.getContentImage(adsIsEnable, isUserFreemiumOrFreemiumLoggedOrNavPremium)}
                        contentTitle={contentTitle}
                        contentOriginalTitle={contentOriginalTitle}
                        titleSerie={titleSerie}
                        contentNotes={disclaimer}
                        providerImage={this.getProviderImage(adsIsEnable, isUserFreemiumOrFreemiumLoggedOrNavPremium, isPlanSelectorCintillo)}
                        frequency={frequency}
                        duration={Translator.get(periodicity)}
                        information={information}
                        lblTotal={`${Translator.get('subscription_totalCost_description_label', 'Total:')}`}
                        handleAcceptSavedPayway={this.handleAcceptSavedPayway}
                        handleAddPayway={this.handleAddPayway}
                        handleCancelPayway={this.handleCancelPayway}
                        selectedPaymentMethod={this.getPaymentMethod()}
                        textAcceptSavedPayway={this.getTextButtonAccept()}
                        textCancelButton={Translator.get(`checkout_access_option_button_cancel`, 'CANCELAR')}
                        textAddPayway={this.getTextAddPaywayButton(hasSavedPayway)}
                        showSavedPaywayButton={showSavedPaywayButton}
                        showAddPaywayButton={showAddPaywayButton}
                        textStep={this.from ? Translator.get('top_head_step_2_3_label', 'PASO 2 DE 3') : ''}
                        extraDisclaimer={extra_disclaimer}
                        className={Device.getDevice().getPlatform()}
                        checkoutPrice={checkoutPrice}
                        checkoutTax={checkoutTax}
                        checkoutBonus={checkoutBonus}
                        isFreemium = {isFreemium}
                        textNextFreemium={this.getTextButtonnNextFreemium()}
                        rentaDescripcionContent={rentaDescripcionContent}
                        handleLoginFreemium = {this.handleLoginFreemium}
                        textBuySuscription = {textBuySuscription}
                        checkoutTaxPublicity = {checkoutTaxPublicity}
                        adsIsEnable = {adsIsEnable}
                        textDescriptionContent = {textDescriptionContent}
                        titleTitlePublicity = {titleTitlePublicity}
                        imagePublicity = {imagePublicity}
                        payment_methods_experience={enablePaymentMethodExperience()}
                    />
                </Grid>
            )
        }
    }
}

const mapDispatchToProps = {
    setMetricsEvent
}

export default connect(null, mapDispatchToProps)(TransactionDetailContainer)



// WEBPACK FOOTER //
// ./src/payments/Checkout/index.tsx